import {
  FormStore,
  useFormStoreActions,
  useFormStoreState,
} from "./form-store";
import React, { useState } from "react";
import "styled-components/macro";
import { FormWrapper } from "./form-wrapper";
import { Drawer } from "@blueprintjs/core";

import { DRAWER_WIDTH } from "../../styles/constants";
import { useDrawerForm } from "../../store/model-drawer-form";

export function DrawerFormWrapper() {
  const { isOpen } = useDrawerForm();
  return isOpen && <DrawerForm />;
}

function DrawerForm() {
  return (
    <MyDrawer>
      <MyFormStoreProvider>
        <FormWrapper>
          <FormContent />
        </FormWrapper>
      </MyFormStoreProvider>
    </MyDrawer>
  );
}

function MyDrawer({ children }) {
  const { isOpen, close, title } = useDrawerForm();
  return (
    <Drawer
      canEscapeKeyClose={false}
      isCloseButtonShown={true}
      isOpen={isOpen}
      onClose={close}
      className="bp3-dark"
      size={DRAWER_WIDTH}
      title={title}
    >
      <div
        css={`
          padding: 24px;
          overflow-y: auto;
          height: 100%;
        `}
      >
        {children}
      </div>
    </Drawer>
  );
}
function MyFormStoreProvider({ children }) {
  const { initialData, formStoreModelFactory } = useDrawerForm();
  return (
    <FormStore.Provider
      initialData={{
        initialData,
        formStoreModelFactory,
      }}
    >
      {children}
    </FormStore.Provider>
  );
}

function FormContent() {
  const { ContentComponent } = useDrawerForm();
  const formState = useFormStoreState();
  const formActions = useFormStoreActions();
  const [activeField, setActiveField] = useState(null);

  return (
    <ContentComponent
      formState={formState}
      formActions={formActions}
      activeField={activeField}
      setActiveField={setActiveField}
    />
  );
}
